import { render, staticRenderFns } from "./RiskStandardBus.vue?vue&type=template&id=6f6818ec&scoped=true"
import script from "./RiskStandardBus.vue?vue&type=script&lang=js"
export * from "./RiskStandardBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6818ec",
  null
  
)

export default component.exports